const DashboardFilters = ({ filters, onChange, onApply }) => {
  return (
    <div className="dashboard-filters date-only">
      <div className="filter-group">
        <label>From Date</label>
        <input
          type="date"
          value={filters.fromDate}
          onChange={(e) =>
            onChange({
              ...filters,
              fromDate: e.target.value,
            })
          }
        />
      </div>

      <div className="filter-group">
        <label>To Date</label>
        <input
          type="date"
          value={filters.toDate}
          onChange={(e) =>
            onChange({
              ...filters,
              toDate: e.target.value,
            })
          }
        />
      </div>

      <button className="apply-btn" onClick={onApply}>Apply Filter</button>
    </div>
  );
};

export default DashboardFilters;
